import { render, staticRenderFns } from "./AgentSideMenu.vue?vue&type=template&id=c5824624&scoped=true"
import script from "./AgentSideMenu.vue?vue&type=script&lang=ts"
export * from "./AgentSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./AgentSideMenu.vue?vue&type=style&index=0&id=c5824624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5824624",
  null
  
)

export default component.exports